export default "__VITE_ASSET__Cf99e5xF__"